import { PaginatedActivities, Activity } from '../types/Activity';

// Mock data for testing while backend CORS is being resolved
const mockActivities: Activity[] = [
  {
    id: 1,
    title: "Morning Yoga in Central Park",
    description: "Start your day with peaceful yoga session in the heart of the city. Perfect for all skill levels, we'll focus on mindfulness and gentle stretching.",
    category: {
      id: 1,
      name: "Wellness",
      description: "Health and wellness activities",
      created_at: "2024-07-01T10:00:00Z",
      updated_at: "2024-07-01T10:00:00Z"
    },
    category_id: 1,
    tags: [
      { id: 1, name: "Outdoor", created_at: "2024-07-01T10:00:00Z", updated_at: "2024-07-01T10:00:00Z" },
      { id: 2, name: "Beginner-Friendly", created_at: "2024-07-01T10:00:00Z", updated_at: "2024-07-01T10:00:00Z" }
    ],
    tags_id: [1, 2],
    date: "2024-07-25",
    time: "07:00:00",
    end_time: "08:30:00",
    location_name: "Central Park Sheep Meadow",
    address: "Central Park West & 69th St",
    city: "New York",
    country: "US",
    country_name: "United States",
    full_address: "Central Park West & 69th St, New York, United States",
    latitude: 40.7713,
    longitude: -73.9757,
    current_participants: 12,
    participants_preview: [
      { id: "mock-user-1", name: "Olivia", profile_picture_url: "https://randomuser.me/api/portraits/women/65.jpg" },
      { id: "mock-user-2", name: "Liam", profile_picture_url: "https://randomuser.me/api/portraits/men/45.jpg" },
      { id: "mock-user-3", name: "Sofia", profile_picture_url: null }
    ],
    pending_attendee_count: 3,
    max_participants: 20,
    organizer_id: "user-123",
    organizer_name: "Sarah Johnson",
    image_url: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=300&fit=crop",
    event_type: "PUBLIC_GROUP",
    skill_level: "BEGINNER",
    is_organizer: false,
    is_registered: false,
    confirmed_attendee_ids: ["user-123", "user-456"],
    group: undefined,
    group_id: undefined,
    is_private: false,
    group_name: undefined,
    group_member_count: undefined,
    created_at: "2024-07-01T10:00:00Z",
    updated_at: "2024-07-10T12:00:00Z",
    creator: "user-123"
  },
  {
    id: 2,
    title: "Evening Photography Walk",
    description: "Capture the golden hour beauty of the city! Join us for a photography walk through historic neighborhoods. Bring your camera or smartphone.",
    category: {
      id: 2,
      name: "Arts & Culture",
      description: "Creative and cultural activities",
      created_at: "2024-07-01T10:00:00Z",
      updated_at: "2024-07-01T10:00:00Z"
    },
    category_id: 2,
    tags: [
      { id: 3, name: "Photography", created_at: "2024-07-01T10:00:00Z", updated_at: "2024-07-01T10:00:00Z" },
      { id: 4, name: "Walking", created_at: "2024-07-01T10:00:00Z", updated_at: "2024-07-01T10:00:00Z" },
      { id: 5, name: "Creative", created_at: "2024-07-01T10:00:00Z", updated_at: "2024-07-01T10:00:00Z" }
    ],
    tags_id: [3, 4, 5],
    date: "2024-07-26",
    time: "18:00:00",
    end_time: "20:00:00",
    location_name: "Brooklyn Bridge",
    address: "Brooklyn Bridge, New York",
    city: "New York",
    country: "US",
    country_name: "United States",
    full_address: "Brooklyn Bridge, New York, United States",
    latitude: 40.7061,
    longitude: -73.9969,
    current_participants: 8,
    participants_preview: [
      { id: "mock-user-4", name: "Noah", profile_picture_url: "https://randomuser.me/api/portraits/men/12.jpg" },
      { id: "mock-user-5", name: "Emma", profile_picture_url: "https://randomuser.me/api/portraits/women/12.jpg" },
      { id: "mock-user-6", name: "Lucas", profile_picture_url: null }
    ],
    pending_attendee_count: 2,
    max_participants: 15,
    organizer_id: "user-789",
    organizer_name: "Mike Chen",
    image_url: "https://images.unsplash.com/photo-1516035069371-29a1b244cc32?w=500&h=300&fit=crop",
    event_type: "PUBLIC_GROUP",
    skill_level: "INTERMEDIATE",
    is_organizer: false,
    is_registered: false,
    confirmed_attendee_ids: ["user-789", "user-101"],
    group: undefined,
    group_id: undefined,
    is_private: false,
    group_name: undefined,
    group_member_count: undefined,
    created_at: "2024-07-01T10:00:00Z",
    updated_at: "2024-07-10T12:00:00Z",
    creator: "user-789"
  },
  {
    id: 3,
    title: "Weekend Hiking Adventure",
    description: "Escape the city for a challenging mountain hike! We'll explore scenic trails, enjoy breathtaking views, and connect with nature.",
    category: {
      id: 3,
      name: "Sports & Fitness",
      description: "Sports and fitness activities",
      created_at: "2024-07-01T10:00:00Z",
      updated_at: "2024-07-01T10:00:00Z"
    },
    category_id: 3,
    tags: [
      { id: 6, name: "Hiking", created_at: "2024-07-01T10:00:00Z", updated_at: "2024-07-01T10:00:00Z" },
      { id: 7, name: "Adventure", created_at: "2024-07-01T10:00:00Z", updated_at: "2024-07-01T10:00:00Z" },
      { id: 1, name: "Outdoor", created_at: "2024-07-01T10:00:00Z", updated_at: "2024-07-01T10:00:00Z" }
    ],
    tags_id: [6, 7, 1],
    date: "2024-07-27",
    time: "08:00:00",
    end_time: "16:00:00",
    location_name: "Bear Mountain State Park",
    address: "Bear Mountain, NY 10911",
    city: "Bear Mountain",
    country: "US",
    country_name: "United States",
    full_address: "Bear Mountain, NY 10911, United States",
    latitude: 41.3182,
    longitude: -74.0137,
    current_participants: 15,
    participants_preview: [
      { id: "mock-user-7", name: "Mia", profile_picture_url: "https://randomuser.me/api/portraits/women/33.jpg" },
      { id: "mock-user-8", name: "Ethan", profile_picture_url: "https://randomuser.me/api/portraits/men/33.jpg" },
      { id: "mock-user-9", name: "Zara", profile_picture_url: null }
    ],
    pending_attendee_count: 5,
    max_participants: 25,
    organizer_id: "user-456",
    organizer_name: "Alex Rodriguez",
    image_url: "https://images.unsplash.com/photo-1551632811-561732d1e306?w=500&h=300&fit=crop",
    event_type: "PUBLIC_GROUP",
    skill_level: "INTERMEDIATE",
    is_organizer: false,
    is_registered: false,
    confirmed_attendee_ids: ["user-456", "user-789"],
    group: undefined,
    group_id: undefined,
    is_private: false,
    group_name: undefined,
    group_member_count: undefined,
    created_at: "2024-07-01T10:00:00Z",
    updated_at: "2024-07-10T12:00:00Z",
    creator: "user-456"
  },
  {
    id: 4,
    title: "Cooking Class: Italian Pasta",
    description: "Learn to make authentic Italian pasta from scratch! We'll cover traditional techniques and create delicious sauces to pair with our homemade pasta.",
    category: {
      id: 4,
      name: "Food & Drinks",
      description: "Culinary experiences and food events",
      created_at: "2024-07-01T10:00:00Z",
      updated_at: "2024-07-01T10:00:00Z"
    },
    category_id: 4,
    tags: [
      { id: 8, name: "Cooking", created_at: "2024-07-01T10:00:00Z", updated_at: "2024-07-01T10:00:00Z" },
      { id: 9, name: "Italian", created_at: "2024-07-01T10:00:00Z", updated_at: "2024-07-01T10:00:00Z" },
      { id: 10, name: "Hands-on", created_at: "2024-07-01T10:00:00Z", updated_at: "2024-07-01T10:00:00Z" }
    ],
    tags_id: [8, 9, 10],
    date: "2024-07-28",
    time: "14:00:00",
    end_time: "17:00:00",
    location_name: "Culinary Institute Studio",
    address: "123 Kitchen Ave",
    city: "New York",
    country: "US",
    country_name: "United States",
    full_address: "123 Kitchen Ave, New York, United States",
    latitude: 40.7580,
    longitude: -73.9855,
    current_participants: 6,
    participants_preview: [
      { id: "mock-user-10", name: "Ava", profile_picture_url: "https://randomuser.me/api/portraits/women/75.jpg" },
      { id: "mock-user-11", name: "Leo", profile_picture_url: "https://randomuser.me/api/portraits/men/75.jpg" },
      { id: "mock-user-12", name: "Nina", profile_picture_url: null }
    ],
    pending_attendee_count: 1,
    max_participants: 12,
    organizer_id: "user-321",
    organizer_name: "Chef Maria Rossi",
    image_url: "https://images.unsplash.com/photo-1473093295043-cdd812d0e601?w=500&h=300&fit=crop",
    event_type: "PUBLIC_GROUP",
    skill_level: "BEGINNER",
    is_organizer: false,
    is_registered: false,
    confirmed_attendee_ids: ["user-321", "user-654"],
    group: undefined,
    group_id: undefined,
    is_private: false,
    group_name: undefined,
    group_member_count: undefined,
    created_at: "2024-07-01T10:00:00Z",
    updated_at: "2024-07-10T12:00:00Z",
    creator: "user-321"
  }
];

export const fetchMockActivities = async (page: number = 1): Promise<PaginatedActivities> => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  const itemsPerPage = 4;
  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedResults = mockActivities.slice(startIndex, endIndex);
  
  return {
    count: mockActivities.length,
    next: endIndex < mockActivities.length ? `mock-url?page=${page + 1}` : undefined,
    previous: page > 1 ? `mock-url?page=${page - 1}` : undefined,
    results: paginatedResults
  };
}; 